<div *ngIf="payment" class="stmnt_footer_paid align_center">
  <div class="data_row no_padding compact">
    <div class="data_label">Check No. {{ payment?.checkNo }}</div>
  </div>
  <div class="data_row no_padding compact">
    <div class="data_label">Paid</div>
    <div class="data_value large_text">${{ total | number: "1.2-2":"en-US" }}</div>
  </div>
</div>
